import React from 'react'
import PropTypes from 'prop-types'

import NavHighlighter from 'components/NavHighlighter'

const Sidebar = props => {
  const headingClasses = props.sidebarData.opened ? 'hidden' : 'heading'
  return (
    <div className="page-sidebar-wrapper">
      <div className="page-sidebar navbar-collapse collapse">
        <ul
          className={props.sidebarData.ulClass}
          data-keep-expanded="false"
          data-auto-scroll="true"
          data-slide-speed="200"
        >
          <li className="sidebar-toggler-wrapper hide">
            <button
              className="sidebar-toggler"
              onClick={() => props.handleSidebar(props.sidebarData)}
            >
              <span />
            </button>
          </li>
          <NavHighlighter className="nav-item" to="/" pathname={props.pathname}>
            <i className="icon-home" />
            <span className="title">Home</span>
          </NavHighlighter>
          <li className={headingClasses}>
            <h3 className="uppercase">Users</h3>
          </li>
          <NavHighlighter className="nav-item" to="/users" pathname={props.pathname}>
            <i className="icon-users" />
            <span className="title">Users</span>
          </NavHighlighter>
          <NavHighlighter
            className="nav-item"
            to="/admin-created-user"
            pathname={props.pathname}
          >
            <i className="fa fa-users fa-inverse" />
            <span className="title">Admin-Created Users</span>
          </NavHighlighter>

          <li className={headingClasses}>
            <h3 className="uppercase">Profiles</h3>
          </li>
          <NavHighlighter className="nav-item" to="/profiles" pathname={props.pathname}>
            <i className="fa fa-laptop" />
            <span className="title">Profiles</span>
          </NavHighlighter>
          <NavHighlighter
            className="nav-item"
            to="/finance_profiles"
            pathname={props.pathname}
          >
            <i className="fa fa-money" />
            <span className="title">Pending Finance Profiles</span>
          </NavHighlighter>
          <NavHighlighter
            className="nav-item"
            to="/profiles_bank_information"
            pathname={props.pathname}
          >
            <i className="fa fa-credit-card" />
            <span className="title">Profiles Bank Information</span>
          </NavHighlighter>

          <li className={headingClasses}>
            <h3 className="uppercase">Services management</h3>
          </li>
          <NavHighlighter
            className="nav-item"
            to="/category-management"
            pathname={props.pathname}
          >
            <i className="icon-check" />
            <span className="title">Category management</span>
          </NavHighlighter>
          <NavHighlighter
            className="nav-item"
            to="/industrial-and-expertise"
            pathname={props.pathname}
          >
            <i className="icon-check" />
            <span className="title">Industry & Expertise</span>
          </NavHighlighter>
          <NavHighlighter
            className="nav-item"
            to="/occupations-management"
            pathname={props.pathname}
          >
            <i className="icon-check" />
            <span className="title">Occupations management</span>
          </NavHighlighter>
          <NavHighlighter className="nav-item" to="/products" pathname={props.pathname}>
            <i className="icon-check" />
            <span className="title">Published Services</span>
          </NavHighlighter>
          <NavHighlighter
            className="nav-item"
            to="/pending-products"
            pathname={props.pathname}
          >
            <i className="icon-close" />
            <span className="title">Need Review</span>
          </NavHighlighter>
          {/* TODO: DELETE AFTER CONFIRMATION FROM USERS
          <NavHighlighter className="nav-item" to="/products-brand-new" pathname={props.pathname}>
            <i className="icon-plus" />
            <span className="title">Brand New Services</span>
          </NavHighlighter> */}

          <li className={headingClasses}>
            <h3 className="uppercase">Finance</h3>
          </li>
          <NavHighlighter
            className="nav-item"
            to="/payment-list"
            pathname={props.pathname}
          >
            <i className="mdi mdi-debug-step-into" />
            <span className="title">Payment List</span>
          </NavHighlighter>

          <li className={headingClasses}>
            <h3 className="uppercase">Organisations</h3>
          </li>
          <NavHighlighter className="nav-item" to="/projects" pathname={props.pathname}>
            <i className="icon-calendar" />
            <span className="title">Projects</span>
          </NavHighlighter>
          <NavHighlighter
            className="nav-item"
            to="/payment_confirmation"
            pathname={props.pathname}
          >
            <i className="icon-fire" />
            <span className="title">Paid Invoice Approval</span>
          </NavHighlighter>

          <li className={headingClasses}>
            <h3 className="uppercase">Settings</h3>
          </li>
          <NavHighlighter className="nav-item" to="/banks" pathname={props.pathname}>
            <i className="fa fa-usd" />
            <span className="title">Banks</span>
          </NavHighlighter>
          <NavHighlighter
            className="nav-item"
            to="/country_taxes"
            pathname={props.pathname}
          >
            <i className="fa fa-usd" />
            <span className="title">Country Taxes + Fees</span>
          </NavHighlighter>
          <NavHighlighter
            className="nav-item"
            to="/product_languages"
            pathname={props.pathname}
          >
            <i className="fa fa-language fa-inverse" />
            <span className="title">Service Languages</span>
          </NavHighlighter>
          <NavHighlighter className="nav-item" to="/tax" pathname={props.pathname}>
            <i className="fa fa-user-secret" />
            <span className="title">Tax Serial</span>
          </NavHighlighter>
          <NavHighlighter className="nav-item" to="/emails" pathname={props.pathname}>
            <i className="fa fa-envelope" />
            <span className="title">Emails</span>
          </NavHighlighter>
        </ul>
      </div>
    </div>
  )
}

Sidebar.defaultProps = {
  pathname: '',
  sidebarData: {
    opened: true,
    ulClass: '',
  },
}

Sidebar.propTypes = {
  pathname: PropTypes.string.isRequired,
  sidebarData: PropTypes.shape({
    opened: PropTypes.bool.isRequired,
    ulClass: PropTypes.string.isRequired,
  }).isRequired,
  handleSidebar: PropTypes.func.isRequired,
}

export default Sidebar
